export { default as Switch } from './view'
export type { Props as SwitchProps } from './view'
